import type { SyncHasMany } from "@ember-data/model";
import Model, { attr, hasMany } from "@ember-data/model";
import type TherapeuticalArea from "./therapeutical-area";

export default class Image extends Model {
  @attr() ccam;
  @attr() label;
  @hasMany("therapeutical-area", { async: false, inverse: "images" })
  declare therapeuticalAreas: SyncHasMany<TherapeuticalArea>;
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    image: Image;
  }
}
